import * as audience from "./action-types/action-types-audience";
import * as lastPost from "./action-types/action-types-last-post";
import * as blocked from "./action-types/action-types-blocked";
import * as activity from "./action-types/action-types-activity";

export {audience, lastPost, blocked, activity};

export const NAMESPACE = 'COMMUNITIES_FILTER/';
export const SET_SEARCH_TYPE = NAMESPACE + 'SET_SEARCH_TYPE';
